import { render, staticRenderFns } from "./ModalAcceptedHistory.vue?vue&type=template&id=4d5886ed&scoped=true&"
import script from "./ModalAcceptedHistory.vue?vue&type=script&lang=js&"
export * from "./ModalAcceptedHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalAcceptedHistory.vue?vue&type=style&index=0&id=4d5886ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5886ed",
  null
  
)

export default component.exports